module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.renderData && _vm.renderData.length && _vm.renderData.length > 1) ? _c('div', {
    staticClass: "topsellingcard",
    class: _vm.isFilterLanding ? 'filter-landing-topselling-card' : null
  }, [_c('div', {
    staticClass: "topsellingcard__title-cont"
  }, [(_vm.callerComp === 'summerCollection') ? _c('div', {
    staticClass: "heading_container"
  }, [_c('img', {
    attrs: {
      "data-src": _vm.isDesktop ? _vm.baseImgServerUrl + 'tile-side-design.png' : _vm.baseImgServerUrl + 'tile-side-design-mobile.png',
      "alt": "Zig Zag lines"
    }
  }), _vm._v(" "), (_vm.renderName) ? _c('h3', {
    staticClass: "summer-collection-heading"
  }, [_vm._v(_vm._s(_vm.renderName))]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "data-src": _vm.isDesktop ? _vm.baseImgServerUrl + 'tile-side-design.png' : _vm.baseImgServerUrl + 'tile-side-design-mobile.png',
      "alt": "Zig Zag lines"
    }
  })]) : (_vm.isFilterLanding) ? _c('div', {
    staticClass: "title-container"
  }, [(_vm.renderName) ? _c('div', {
    staticClass: "category-title-container"
  }, [_c('div', {
    staticClass: "mobile-lines-container"
  }, _vm._l((_vm.deviceWidth), function(e, i) {
    return _c('div', {
      key: i,
      staticClass: "rotate-line"
    }, [_vm._v("|")])
  })), _vm._v(" "), _c('h3', {
    staticClass: "filter-landing-title"
  }, [_vm._v(_vm._s(_vm.renderName))])]) : _vm._e()]) : (_vm.renderName) ? _c('h3', {
    staticClass: "title",
    class: !_vm.isDesktop ? 'text-left pl-4' : ''
  }, [_vm._v(_vm._s(_vm.renderName))]) : _vm._e(), _vm._v(" "), (_vm.getDescription) ? _c('p', {
    staticClass: "descrition"
  }, [_vm._v(_vm._s(_vm.getDescription))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    ref: "my-carousel",
    staticClass: "bannerview mobileBannerView",
    attrs: {
      "navigationEnabled": _vm.isDesktop,
      "paginationEnabled": !_vm.isDesktop,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "loop": true,
      "autoplay": _vm.shouldAutoPlay,
      "paginationPadding": 1,
      "autoplayTimeout": 6000,
      "speed": 500,
      "paginationColor": _vm.isFilterLanding ? '#979a9f' : '',
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4]
      ],
      "perPage": 2,
      "paginationSize": 6
    }
  }, _vm._l((_vm.productsListing && _vm.productsListing.slice(0, _vm.productsListing.length - 1)), function(prm, index) {
    return _c('slide', {
      key: index,
      staticClass: "col-md-3 col-6"
    }, [(_vm.callerComp === 'new arrival' || _vm.isRecommendedTopSelling) ? _c('div', [_c('TopSellingImgBlock', {
      attrs: {
        "parry": prm.imageUrl && prm.imageUrl[0] ? _vm.baseImgPath + _vm.path + prm.imageUrl[0] : '',
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.productUrl,
        "productTitle": prm.title,
        "productCat": prm.category && prm.category[0],
        "productPrice": parseInt(prm.price),
        "pclass": 'itemsmall',
        "souledout": false,
        "spprice": parseInt(prm.spl_price),
        "exclusivePrice": prm.exclusive_price,
        "isExclusive": _vm.isExclusive,
        "renderName": _vm.renderName,
        "callerComp": _vm.callerComp,
        "genderType": prm.gender ? 2 : 1,
        "cardStyle": _vm.isFilterLanding && !_vm.isDesktop ? {
          border: '1px solid #e8e8e8'
        } : ''
      }
    })], 1) : _c('div', [_c('TopSellingImgBlock', {
      attrs: {
        "parry": prm.image,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product_name,
        "productCat": prm.product_type,
        "productPrice": parseInt(prm.original_price),
        "product": prm,
        "isWidgetProduct": _vm.isWidgetProduct,
        "pclass": 'itemsmall',
        "souledout": false,
        "spprice": parseInt(prm.spl_price),
        "exclusivePrice": prm.exclusive_price,
        "isExclusive": _vm.isExclusive,
        "renderName": _vm.renderName,
        "callerComp": _vm.callerComp,
        "genderType": prm.gender ? 2 : 1,
        "cardStyle": _vm.isFilterLanding && !_vm.isDesktop ? {
          border: '1px solid #e8e8e8'
        } : '',
        "widgetType": _vm.widgetType
      }
    })], 1)])
  }))], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f58a97f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TopSellingSection.vue
// module id = 1303
// module chunks = 5 19 99 101